import { render, staticRenderFns } from "./invoice-status.vue?vue&type=template&id=0788930c&scoped=true"
import script from "./invoice-status.vue?vue&type=script&lang=js"
export * from "./invoice-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788930c",
  null
  
)

export default component.exports